var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.image = exports.webText = exports.text = exports.webView = exports.view = exports.bordering = exports.positioning = exports.centering = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

var _styledSystem = require("@sport1/styled-system");

var _Helper = require("./Helper");

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", ";\n    ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", "\n    ", "\n    ", ";\n     ", "\n    ", "\n    ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  font-family: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", "\n  ", ";\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", " ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", " ", "\n  /* We need this, otherwise there is always a 3px border by default */\n  border-width: 0px;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var centering = (0, _styledComponents.css)(_templateObject());
exports.centering = centering;
var positioning = (0, _styledComponents.css)(_templateObject2(), _styledSystem.position, _styledSystem.top, _styledSystem.left, _styledSystem.right, _styledSystem.bottom);
exports.positioning = positioning;
var bordering = (0, _styledComponents.css)(_templateObject3(), _styledSystem.borderColor, _styledSystem.borderRadius, function (props) {
  return props.borderX !== undefined && "\n      border-top-width: " + props.borderX + "px;\n      border-bottom-width: " + props.borderX + "px;\n      border-style: solid;\n  ";
}, function (props) {
  return props.borderY !== undefined && "\n      border-left-width: " + props.borderY + "px;\n      border-right-width: " + props.borderY + "px;\n      border-style: solid;\n  ";
}, function (props) {
  return props.borderBottom !== undefined && "\n      border-bottom-width: " + props.borderBottom + "px;\n      border-style: solid;\n  ";
}, function (props) {
  return props.borderTop !== undefined && "\n      border-top-width: " + props.borderTop + "px;\n      border-style: solid;\n  ";
}, function (props) {
  return props.borderLeft !== undefined && "\n      border-left-width: " + props.borderLeft + "px;\n      border-style: solid;\n  ";
}, function (props) {
  return props.borderRight !== undefined && "\n      border-right-width: " + props.borderRight + "px;\n      border-style: solid;\n  ";
});
exports.bordering = bordering;
var view = (0, _styledComponents.css)(_templateObject4(), _styledSystem.space, _styledSystem.color, _styledSystem.width, _styledSystem.maxWidth, _styledSystem.maxHeight, _styledSystem.minHeight, _styledSystem.height, _styledSystem.hover, _styledSystem.boxShadow, _styledSystem.zIndex, bordering, positioning, _styledSystem.justifyContent, _styledSystem.alignItems, _styledSystem.backgroundImage, _styledSystem.backgroundSize, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.minWidth, _styledSystem.flexWrap, _styledSystem.textAlign, function (props) {
  return props.row && 'flex-direction: row;';
}, function (props) {
  return props.reverseRow && 'flex-direction: row-reverse;';
}, function (props) {
  return props.column && 'flex-direction: column;';
}, function (props) {
  return props.reverseColumn && 'flex-direction: column-reverse;';
}, function (props) {
  return props.evenly && 'justify-content: space-between;';
}, function (props) {
  return props.alignRight && 'align-items: flex-end; justify-content: flex-end;';
}, function (props) {
  return props.alignLeft && 'justify-content: flex-start; align-items: flex-start;';
}, function (props) {
  return props.center && 'justify-content: center; align-items: center;';
}, function (props) {
  return props.centerHorizontal && 'align-items: center;';
}, function (props) {
  return props.centerVertical && 'justify-content: center; align-items: flex-start;';
}, function (props) {
  return props.flexing && 'display: flex; flex: 1;';
}, function (props) {
  return props.isFlex && 'display: flex;';
}, function (props) {
  return typeof props.flexShrink === 'number' && "flex-shrink: " + props.flexShrink + ";";
}, function (props) {
  return props.rotate && "transform: rotate(" + props.rotate + "deg);";
}, function (props) {
  return props.overflow && "overflow: " + props.overflow + ";";
}, function (props) {
  return typeof props.opacity === 'number' && "opacity: " + props.opacity;
}, function (props) {
  return props.alignSelf && "align-self: " + props.alignSelf;
}, _styledSystem.display);
exports.view = view;
var webView = (0, _styledComponents.css)(_templateObject5(), _styledSystem.flex, function (props) {
  return props.row && !props.display && "display: flex;";
}, function (props) {
  return props.column && !props.display && "display: flex;";
}, function (props) {
  return props.borderBox && 'box-sizing: border-box;';
}, function (props) {
  return props.pointer && "cursor: pointer;";
}, function (props) {
  return props.iosOverflow && "-webkit-overflow-scrolling: touch;";
}, function (props) {
  return props.wrapContent && "\n            flex: 1;\n            display: block;\n            &, & > * {\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n    ";
}, function (props) {
  return props.hideScrollbar && "::-webkit-scrollbar { \n    display: none; \n }";
}, function (props) {
  return props.gradient && props.gradient.start && props.gradient.end && props.gradient.direction && "background: linear-gradient(" + props.gradient.direction + ", " + props.gradient.start + " , " + props.gradient.end + ");\n    ";
});
exports.webView = webView;

var textSizes = function textSizes(props) {
  switch (props.size) {
    case 'small':
      return "\n              font-size: " + (0, _styledSystem.themeGet)('fontSizes.0', '8px')(props) + ";\n          ";

    case 'medium':
      return "\n              font-size: " + (0, _styledSystem.themeGet)('fontSizes.1', '20px')(props) + ";\n          ";

    case 'large':
      return "\n              font-size: " + (0, _styledSystem.themeGet)('fontSizes.2', '18px')(props) + ";\n=          ";

    case 'largest':
      return "\n              font-size: " + (0, _styledSystem.themeGet)('fontSizes.3', '40px')(props) + ";\n          ";

    case 'arrowSize':
      return "\n              font-size: " + (0, _styledSystem.themeGet)('arrowSize', '28px')(props) + ";\n          ";

    default:
      return '';
  }
};

var text = (0, _styledComponents.css)(_templateObject6(), _styledSystem.space, _styledSystem.color, _styledSystem.fontWeight, _styledSystem.textAlign, bordering, positioning, _styledSystem.flexWrap, _styledSystem.zIndex, function (props) {
  return props.theme && props.theme.fontFamily ? props.theme.fontFamily : 'Sport1-Regular';
}, function (props) {
  return props.fontello && "font-family: fontello;";
}, function (props) {
  return props.bold && "font-weight: " + (props.theme && props.theme.fontFamilyBold ? 'bold' : 'normal') + ";font-family: " + (props.theme && props.theme.fontFamilyBold ? props.theme.fontFamilyBold : 'Sport1-Bold') + ";";
}, function (props) {
  return props.alignRight && 'text-align: right';
}, function (props) {
  return props.center && 'text-align: center';
}, function (props) {
  return props.grow && 'flex: 1';
}, function (props) {
  return typeof props.flexShrink === 'number' && "flex-shrink: " + props.flexShrink + ";";
}, function (props) {
  return props.rotate && "transform: rotate(" + props.rotate + "deg);";
}, function (props) {
  return props.opacity && "opacity: " + props.opacity;
}, function (props) {
  return props.overflow && "overflow: " + props.overflow + ";";
}, function (props) {
  return props.underline && 'text-decoration: underline;';
}, _styledSystem.fontSize, function (props) {
  return typeof props.fontSize === 'undefined' && textSizes(props);
}, _styledSystem.lineHeight, function (props) {
  return typeof props.lineHeight === 'undefined' && (0, _Helper.lineHeights)(props);
}, _styledSystem.display);
exports.text = text;
var webText = (0, _styledComponents.css)(_templateObject7(), _styledSystem.minWidth, _styledSystem.width, function (props) {
  return (props.textWrap || props.numberOfLines === 1) && 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;';
}, function (props) {
  if (props.numberOfLines && props.numberOfLines > 1 && (props.lineHeight || props.size)) {
    props.maxHeight = (0, _Helper.getMaxHeight)(props);
    return "display: -webkit-box; -webkit-line-clamp: " + props.numberOfLines + "; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;";
  }

  return '';
}, function (props) {
  return props.noSelect && 'user-select: none;';
}, _styledSystem.maxHeight);
exports.webText = webText;
var image = (0, _styledComponents.css)(_templateObject8(), _styledSystem.space, function (props) {
  return props.opacity && "opacity: " + props.opacity;
});
exports.image = image;